var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Styles from './checkbox-icon-styles.scss';
const CheckboxIcon = (_a) => {
    var { width = 22, height = 22, fillOpacity = '1', showTick = false, onClick, styles = {} } = _a, props = __rest(_a, ["width", "height", "fillOpacity", "showTick", "onClick", "styles"]);
    return (React.createElement("svg", { "data-testid": props['data-testid'], onClick: onClick, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: Styles.icon, style: styles },
        React.createElement("rect", { className: showTick ? Styles.checked : Styles.unchecked, width: "24", height: "24", rx: "6" }),
        showTick && (React.createElement("path", { d: "M7 12L9.2598 15.0131C9.64114 15.5215 10.3939 15.5499 10.8124 15.0716L17 8", stroke: "white", strokeWidth: "2", strokeLinecap: "round" }))));
};
export default CheckboxIcon;
